import Panel from "./Panel.jsx";
import { formatNumber, formatUsd } from "../lib/utils/formatters.js";

function Metric({ label, value, tone = "text-white" }) {
  return (
    <div className="border-b border-white/10 py-3 last:border-b-0">
      <div className="text-xs text-muted">{label}</div>
      <div className={`mt-1 text-sm font-semibold ${tone}`}>{value}</div>
    </div>
  );
}

export default function TechnicalPanel({ indicators = {}, technicalScore = 0 }) {
  const rsi = Number(indicators.rsi14);
  const rsiTone = rsi > 75 ? "text-rose" : rsi > 68 ? "text-goldSoft" : rsi < 30 ? "text-cyan" : "text-mint";

  return (
    <Panel
      title="Технический анализ"
      icon="chart"
      right={<span className="rounded-md bg-gold/10 px-2 py-1 text-sm font-semibold text-goldSoft">{technicalScore}/100</span>}
    >
      <div className="grid grid-cols-2 gap-x-4 md:grid-cols-3">
        <Metric label="RSI 14" value={formatNumber(indicators.rsi14, 1)} tone={rsiTone} />
        <Metric
          label="MACD"
          value={`${formatNumber(indicators.macdLine, 2)} / ${formatNumber(indicators.signalLine, 2)}`}
        />
        <Metric label="ATR" value={formatNumber(indicators.atr14, 2)} />
        <Metric label="Тренд" value={indicators.trend === "bullish" ? "Бычий" : indicators.trend === "bearish" ? "Медвежий" : "Боковой"} />
        <Metric label="Объем" value={indicators.volume == null ? "Объем недоступен" : formatNumber(indicators.volume, 0)} />
        <Metric label="Поддержка" value={formatUsd(indicators.support)} />
        <Metric label="Сопротивление" value={formatUsd(indicators.resistance)} />
        <Metric label="EMA 21" value={formatUsd(indicators.ema21)} />
        <Metric label="EMA 50" value={formatUsd(indicators.ema50)} />
      </div>
    </Panel>
  );
}
